// Iluminación base — quantum 6D del MMSOR.
//
// - Ambiental azul tenue: temperatura del vacío profundo.
// - Direccional dorada: el "sol" que define las sombras.
// - Puntuales cyan/dorado: acentos cromáticos para el bloom.
//
// 2026-05-05 — Bajamos intensidades. La nueva escena del Domo trae
// 3 pointLights internas + Environment HDRI + reflector de alta
// metalicidad → la suma quemaba todo en blanco. Estas siguen siendo
// los acentos clave pero ya no compiten con las del Domo.
//
// 2026-05-05 v7 — Subimos un poco el ambient (0.22 → 0.32) y sumamos
// un hemisphereLight para que las paredes interiores del Domo nunca
// queden completamente negras desde un ángulo desfavorable. El
// hemisphereLight ilumina el techo con un cyan suave del cielo y el
// piso con un dorado tenue de la tierra — sin esto, en ciertas
// posiciones la cámara veía un "rectángulo negro" donde la pared
// interior del biopolímero no recibía luz directa.

export function Lights() {
    return (
        <>
            <ambientLight intensity={0.32} color="#8FB8FF" />
            <hemisphereLight
                args={["#7DB8FF", "#3F2A1A", 0.45]}
            />
            <directionalLight
                position={[8, 14, 6]}
                intensity={0.55}
                color="#F4E0A0"
                castShadow
                shadow-mapSize-width={2048}
                shadow-mapSize-height={2048}
                shadow-camera-far={50}
                shadow-camera-left={-20}
                shadow-camera-right={20}
                shadow-camera-top={20}
                shadow-camera-bottom={-20}
                shadow-bias={-0.0005}
            />
            <pointLight
                position={[-8, 4, -6]}
                intensity={0.8}
                color="#00E5FF"
                distance={20}
                decay={1.7}
            />
            <pointLight
                position={[7, 2, 5]}
                intensity={0.55}
                color="#D4AF37"
                distance={16}
                decay={1.7}
            />
        </>
    )
}
